import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../../components/fonts/font-props';

import { PolicyResult } from '../../order-eligibility-display.service';
import PolicyResultBadge from '../../ui/policy-result-badge';

import EligibilityCheckMini from './eligibility-check-mini';

interface PolicyResultItemProps {
    policyResult: PolicyResult;
}

const PolicyResultItem: React.FC<PolicyResultItemProps> = ({ policyResult }) => {
    return (
        <div className="policy-result">
            <div className="policy-result-header">
                <FontBody2 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                    {policyResult.name}
                </FontBody2>
                <PolicyResultBadge isPassed={policyResult.isPassed} />
            </div>
            {policyResult.eligibility.map((check, checkIndex) => (
                <EligibilityCheckMini key={checkIndex} check={check} />
            ))}
        </div>
    );
};

export default PolicyResultItem;
